// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1DKmj","footer":"ModalError_footer__14x7h"};